package gr.tech.GRAttestation.sections.tables

import androidx.compose.runtime.Composable
import com.varabyte.kobweb.compose.css.*
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.*
import com.varabyte.kobweb.compose.ui.toAttrs
import com.varabyte.kobweb.silk.components.navigation.Link
import com.varabyte.kobweb.silk.components.navigation.UncoloredLinkVariant
import com.varabyte.kobweb.silk.components.navigation.UndecoratedLinkVariant
import gr.tech.GRAttestation.models.activity.ActivityDTO
import gr.tech.GRAttestation.navigation.AdminSitePage
import gr.tech.GRAttestation.styles.grstyles.BPlaceholder
import gr.tech.GRAttestation.styles.grstyles.Theme
import gr.tech.GRAttestation.util.TimeUtils.formatDateOnly
import org.jetbrains.compose.web.css.px
import org.jetbrains.compose.web.dom.Span
import org.jetbrains.compose.web.dom.Td
import org.jetbrains.compose.web.dom.Text
import org.jetbrains.compose.web.dom.Tr

@Composable
fun AdminStoreSummaryTable(
    activities: List<ActivityDTO>,
) {
    ListTable(
        tableHeaders = listOf("Activity", "User", "Store", "Form", "Created At"),
        items = activities,
        rowContent = { activity ->
            Tr(Modifier.height(57.px).toAttrs()) {
                activity?.let { activity ->
                    Td(
                        attrs = Modifier.maxWidth(325.px).whiteSpace(WhiteSpace.NoWrap)
                            .textOverflow(TextOverflow.Ellipsis).overflow(Overflow.Hidden).toAttrs()
                    ) {
                        Text(activity.activity)
                    }
                    Td { Text(activity.userIdentity) }
                    Td {
                        Link(
                            path = AdminSitePage.Stores.passStoreId(activity.storeId.toString()),
                            variant = UndecoratedLinkVariant.then(UncoloredLinkVariant),
                            modifier = Modifier.textDecorationLine(TextDecorationLine.Underline).color(Theme.DarkGreen.rgb).cursor(Cursor.Pointer)
                        ) {
                            Text((activity.storeId ?: "-").toString())
                        }
                    }
                    Td { Text((activity.formId ?: "-").toString()) }
                    Td {
                        Span { Text(formatDateOnly(activity.createdAt)) }
                        TableDateTimeTooltip(activity.createdAt)
                    }

                } ?: run {
                    Td { BPlaceholder(Modifier.width(200.px)) }
                    Td { BPlaceholder(Modifier.width(100.px)) }
                    Td { BPlaceholder() }
                    Td { BPlaceholder() }
                    Td { BPlaceholder() }
                }
            }
        }
    )
}